import type { Todo } from "../../domain/entities.ts";
import type { StoredEntity } from "../../infrastructure/storage/indexed-db.ts";

export function canCreateTaskInContext(
  rootRole: string,
  selectedCollectionId: string | null,
  collectionRoles: ReadonlyMap<string, string>,
): boolean {
  return rootRole === "owner" || rootRole === "editor" || !!selectedCollectionId && collectionRoles.get(selectedCollectionId) === "editor";
}

export function entityVisibleForScopedAccess(
  entity: StoredEntity,
  scopedRootIds: ReadonlySet<string>,
  sharedTaskIds: ReadonlySet<string>,
  sharedCollectionIds: ReadonlySet<string>,
): boolean {
  if (!scopedRootIds.has(entity.rootId)) return true;
  if (entity.kind === "category") return sharedCollectionIds.has(entity.id);
  if (entity.kind !== "todo") return false;
  const todo = entity.projection as Todo;
  return sharedTaskIds.has(entity.id) || !!todo.categoryId && sharedCollectionIds.has(todo.categoryId);
}
